import { render } from "./LandingHR.vue?vue&type=template&id=181b251c"
import script from "./LandingHR.vue?vue&type=script&lang=js"
export * from "./LandingHR.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__